import { toast } from "react-toastify";
import { SVG_ENUM, TOAST_TYPES_ENUM } from "enums";
import "./Toast.scss";
import SVG from "shared/SVG";
import Button from "../Button/Button";

interface ToastProps {
  message: string;
  type: TOAST_TYPES_ENUM;
  id: string;
  title?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  iconSvg?: SVG_ENUM;
}

const Toast = ({
  message,
  type,
  id,
  title,
  buttonLabel,
  onButtonClick,
  iconSvg,
}: ToastProps) => {
  const handleShowToast = () => {
    switch (type) {
      case TOAST_TYPES_ENUM.SUCCESS:
        toast.update(id, {
          render: (
            <div>
              <h2 className="toast-title toast-title--success">Sukces</h2>
              <p>{message}</p>
            </div>
          ),
          type: "success",
          isLoading: false,
          hideProgressBar: true,
          closeButton: true,
          icon: ({ theme, type }) => <SVG type={SVG_ENUM.EP_SUCCESS} />,
          autoClose: 3000,
        });

        break;
      case TOAST_TYPES_ENUM.ERROR:
        toast.update(id, {
          render: (
            <div>
              <h2 className="toast-title toast-title--failure">Błąd</h2>
              <p>{message}</p>
            </div>
          ),
          type: "error",
          isLoading: false,
          closeButton: true,
          autoClose: 3000,
          hideProgressBar: true,
          icon: ({ theme, type }) => <SVG type={SVG_ENUM.EP_FAIL} />,
        });
        break;
      case TOAST_TYPES_ENUM.LOADING:
        toast.loading(message || "Ładowanie", { toastId: id });
        break;
      case TOAST_TYPES_ENUM.TIME:
        {
          const content = (
            <div className="time-toast">
              <div className="time-toast__inner">
                <div className="time-toast__content">
                  <div className="time-toast__top">
                    <div className="time-toast__icon">
                      <SVG type={SVG_ENUM.RED_CLOCK} />
                    </div>
                    <div>
                      <h2 className="toast-title toast-title--failure">
                        {title || "Twoja sesja wygaśnie za"}
                      </h2>
                      <p className="time-toast__time">
                        <b>{message} min</b>
                      </p>
                    </div>
                  </div>
                  {buttonLabel && onButtonClick && (
                    <Button
                      className="button--rounded time-toast__button button--black"
                      onClick={onButtonClick}
                      label={buttonLabel}
                    />
                  )}
                </div>
              </div>
            </div>
          );

          if (toast.isActive(id)) {
            toast.update(id, {
              render: content,
              type: "error",
              isLoading: false,
              autoClose: false,
              closeButton: false,
              hideProgressBar: true,
              closeOnClick: false,
              draggable: false,
              icon: false,
              className: "toast--time",
            });
            break;
          }

          toast(content, {
            toastId: id,
            type: "error",
            autoClose: false,
            closeButton: false,
            hideProgressBar: true,
            closeOnClick: false,
            draggable: false,
            icon: false,
            className: "toast--time",
          });
        }
        break;
      default: {
        console.error(`Niepoprawny typ notyfikacji (${type})`);
      }
    }
  };

  return <>{handleShowToast()}</>;
};

export default Toast;
